import { useI18n } from '../i18n/I18nProvider';
import type { MessageKey } from '../i18n/i18n';
import { TABS, type Tab } from '../router';
import { Icon, type IconName } from '../ui/Icon';

export function TabBar({ tab, onGo }: { tab: Tab; onGo(t: Tab): void }) {
  const { t } = useI18n();
  return (
    // nav + aria-current 让屏幕阅读器知道"这是主导航、当前在第几项"
    <nav className="tabbar" aria-label={t('tab.lobby')}>
      {TABS.map((name) => (
        <button
          key={name}
          type="button"
          className="tab"
          aria-current={name === tab ? 'page' : undefined}
          onClick={() => onGo(name)}
        >
          <Icon name={name as IconName} className="tab__icon" />
          <span>{t(`tab.${name}` as MessageKey)}</span>
        </button>
      ))}
    </nav>
  );
}
